import React, { createContext, useContext, useMemo } from 'react';
import { colors, Theme, ThemeColors } from '../common/theme-colors';
import useBehaviorSubjectState from './rxjs/useSubjectState';
import { sessionSubject } from '../state/sessionObservable';

export { Theme };

interface ThemeProviderProps {
  children: React.ReactNode;
}

interface ThemeContextValue {
  colors: ThemeColors;
  activeTheme: Theme;
}

export const ThemeContext = createContext<ThemeContextValue>({
  colors: colors.light,
  activeTheme: Theme.LIGHT,
});

const resolveTheme = (raw: string | undefined | null): Theme => {
  return raw?.toLowerCase() === Theme.DARK ? Theme.DARK : Theme.LIGHT;
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { value: session } = useBehaviorSubjectState(sessionSubject);

  const activeTheme = resolveTheme(
    session?.device?.deviceProfile?.customerDisplay?.theme,
  );

  const value = useMemo(
    () => ({
      colors: colors[activeTheme],
      activeTheme,
    }),
    [activeTheme],
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext);
}
